var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row radioGroup",
      attrs: { id: _vm.model.componentSetting.id }
    },
    [
      _c("div", { staticClass: "col-lg-1" }, [
        _vm._v(_vm._s(_vm.model.componentSetting.value))
      ]),
      _c("div", { staticClass: "col-lg-10" }, [
        _c("div", { staticClass: "white-background box-shadow p-4 mb-4" }, [
          _c("h3", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.model.componentSetting.title))
          ]),
          _c("p", { staticClass: "bodytext" }, [
            _vm._v(_vm._s(_vm.model.componentSetting.description))
          ]),
          _c(
            "div",
            { staticClass: "radio-buttons" },
            _vm._l(_vm.getItems, function(item) {
              return item.isEnabled
                ? _c(
                    "div",
                    {
                      class: [
                        item.description != "" && item.description != null
                          ? "span-white-description " + _vm.refresh
                          : "span-simple " + _vm.refresh,
                        "radio-button mb-4"
                      ]
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.model,
                            expression: "data.model"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: _vm.model.componentSetting.id + "_" + item.id,
                          name:
                            _vm.model.componentSetting.id +
                            "_" +
                            _vm.model.componentSetting.name,
                          checked: "false"
                        },
                        domProps: {
                          value: item.id,
                          checked: _vm._q(_vm.data.model, item.id)
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.data, "model", item.id)
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          attrs: {
                            for: _vm.model.componentSetting.id + "_" + item.id
                          }
                        },
                        [
                          _c("span"),
                          _vm._v(_vm._s(item.title) + "\n                    ")
                        ]
                      ),
                      _c("span", { staticClass: "radio-button-description" }, [
                        _vm._v(_vm._s(item.description))
                      ])
                    ]
                  )
                : _vm._e()
            }),
            0
          )
        ])
      ]),
      _c("div", { staticClass: "col-lg-1" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }